import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

// LocalStorage에 보관하지 않으면 새로고침시 데이터 사라짐.
const cite_save = JSON.parse(localStorage.getItem('cite_save'));
const state = {
    cite: []
};

// 저장된 데이터가 있다면 가져온다.
if( cite_save ) state.cite = cite_save;

const mutations = {
    save_cite(state, data) {
        state.cite.push(data);

        // storage 저장
        const cite = JSON.stringify(state.cite);
        localStorage.setItem('cite_save', cite);
    },
    delete_cite(state, index) { // index 받아서 제거 시킴.
        state.cite.splice(index, 1);

        // storage 저장
        const cite = JSON.stringify(state.cite);
        localStorage.setItem('cite_save', cite);
    }
};
export const store = new Vuex.Store({
    state,
    mutations,
    getters: {}
});


// WEBPACK FOOTER //
// ./src/store.js